<template>
  <div class="opposite-ends">
    <i18n-t keypath="NotificationsComponent.DeviceRemovedSuccess" tag="span" scope="global">
      <template #availableInstallations>
        {{ props.notification?.params?.digit ?? "" }}
      </template>
    </i18n-t>
  </div>
</template>

<script setup lang="ts">
import { PropType } from "vue";
import { INotification } from "@/stores/notificationsInterfaces";

const props = defineProps({
  notification: {
    type: Object as PropType<INotification>,
    required: true,
  },
});
</script>
